"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isArrayLike = exports.isArrayLike = function isArrayLike(x) {
  return x && typeof x.length === 'number';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/util/isArrayLike.js
// module id = 156
// module chunks = 177